import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThinkingWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12V19",
			stroke: "white",
			strokeOpacity: .3,
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.93799 15.5L12.0002 12",
			stroke: "white",
			strokeOpacity: .3,
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12L18.0622 8.5",
			stroke: "white",
			strokeOpacity: .3,
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0625 15.5L12.0003 12",
			stroke: "white",
			strokeOpacity: .3,
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12L5.93782 8.5",
			stroke: "white",
			strokeOpacity: .3,
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 5V12",
			stroke: "white",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgThinkingWhite;
